const BASE_WORKFLOW_URL = '/rofl-api/v1';
export const REPORT_URL = `${BASE_WORKFLOW_URL}/reports`;
const DEFAULT_CONTACT_LISTS_URL = '/accounts/contact-lists';
const REDIRECT_URL = {
    CONTACT_LIST_DETAILS: '/accounts/contact-lists',
    ACCOUNT_LIST_DETAILS: '/accounts/account-lists',
    CREATE_CONTACT_LIST: '/accounts/contact-lists/create',
};

/**
 * Returns the url to redirect to. Puts one paramEid after the base url if paramEid exists.
 */
const getRedirectUrl = (base: string, advertisableEid?: string, paramEid?: string) => {
    if (!advertisableEid) {
        return DEFAULT_CONTACT_LISTS_URL;
    }
    return `${base}${paramEid ? `/${paramEid}` : ''}?advertisable=${advertisableEid}`;
};

/**
 * Returns the name of the environment.
 */
export function getEnvironment() {
    if (window.location.hostname === 'app.adroll.com') {
        return 'production';
    }
    if (window.location.hostname === 'staging.internal.adroll.com') {
        return 'staging';
    }
    return 'development';
}

/**
 * Current app path based on env configurations.
 */
export const getBasePath = (): string => {
    return '/workflows';
};

export const getPrBasePath = () => {
    return `${getBasePath()}/${process.env.VERSION}`;
};

export const getAppPath = (path?: string) => {
    const basePath = process.env.ROFL_PR_DEPLOY ? getPrBasePath() : getBasePath();
    if (path) {
        return `${basePath}${path}`;
    }
    return basePath;
};

/**
 * Get contact list pages function section.
 */
export function getContactListDetailsUrl(type?: 'contact' | 'account', contactListEid?: string, advertisableEid?: string) {
    const pathname = type === 'account' ? REDIRECT_URL.ACCOUNT_LIST_DETAILS : REDIRECT_URL.CONTACT_LIST_DETAILS;
    return getRedirectUrl(pathname, advertisableEid, contactListEid);
}

export function getCreateContactListUrl(advertisableEid?: string) {
    return getRedirectUrl(REDIRECT_URL.CREATE_CONTACT_LIST, advertisableEid);
}

export function isNavItemActiveCallback(href: any) {
    const RW_CONTAINER_APP_PATH = '/rw';
    const currentPath = window.location.pathname;
    const appPath = getAppPath();
    const isValidStart = [
        appPath,
        `${RW_CONTAINER_APP_PATH}${appPath}`,
    ].some(path => currentPath.startsWith(path));
    if (isValidStart) {
        return href.startsWith(appPath);
    }
}

/**
 * Returns workflow by eid Route path
 */
export const getWorkflowRoute = () => {
    return getAppPath('/:pathId?');
};

/**
 * Returns workflownotfound path
 */
export const getWorkflowNotFoundRoute = () => {
    return `${getWorkflowRoute()}/notfound`;
};

/**
 * Returns Workflow Setup Route Path
 */
export const getWorkflowSetupRoute = () => {
    return getAppPath('/setup');
};

export const getWorkflowByEidRoute = (workflowEid: string, queryString: string) => {
    return getAppPath(`/${workflowEid}/${queryString}`);
};
